/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LiveSource } from './LiveSource';
import {
    LiveSourceFromJSON,
    LiveSourceFromJSONTyped,
    LiveSourceToJSON,
    LiveSourceToJSONTyped,
} from './LiveSource';
import type { StreamingPlatform } from './StreamingPlatform';
import {
    StreamingPlatformFromJSON,
    StreamingPlatformFromJSONTyped,
    StreamingPlatformToJSON,
    StreamingPlatformToJSONTyped,
} from './StreamingPlatform';
import type { LiveState } from './LiveState';
import {
    LiveStateFromJSON,
    LiveStateFromJSONTyped,
    LiveStateToJSON,
    LiveStateToJSONTyped,
} from './LiveState';
import type { StreamStatus } from './StreamStatus';
import {
    StreamStatusFromJSON,
    StreamStatusFromJSONTyped,
    StreamStatusToJSON,
    StreamStatusToJSONTyped,
} from './StreamStatus';
import type { PresenceOverride } from './PresenceOverride';
import {
    PresenceOverrideFromJSON,
    PresenceOverrideFromJSONTyped,
    PresenceOverrideToJSON,
    PresenceOverrideToJSONTyped,
} from './PresenceOverride';

/**
 * Admin-curated featured stream
 * @export
 * @interface FeaturedStream
 */
export interface FeaturedStream {
    /**
     * 
     * @type {string}
     * @memberof FeaturedStream
     */
    _id?: string;
    /**
     * The roster's LOCAL nickname, and an override rather than the source: a Drop-backed member takes its name from the Drop. Absent for members added that way.
     * @type {string}
     * @memberof FeaturedStream
     */
    label?: string;
    /**
     * 
     * @type {StreamingPlatform}
     * @memberof FeaturedStream
     */
    platform?: StreamingPlatform;
    /**
     * Roster-authored display name. Set explicitly, it wins over the linked Drop's own name, which otherwise takes precedence.
     * @type {string}
     * @memberof FeaturedStream
     */
    overrideName?: string;
    /**
     * Roster-authored image. Wins over every poller-written image and is the only image a member with no Drop and no channel can have.
     * @type {string}
     * @memberof FeaturedStream
     */
    overrideImageUrl?: string;
    /**
     * Values for the fields this member's roster declares, keyed by the schema's field key. Facts about the person, so they travel with them; the roster's schema decides which a surface displays.
     * @type {{ [key: string]: any; }}
     * @memberof FeaturedStream
     */
    fieldValues?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof FeaturedStream
     */
    twitchChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStream
     */
    kickChannelSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStream
     */
    youtubeChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStream
     */
    youtubeLiveId?: string;
    /**
     * The creator's own Drop, when they have one.
     * @type {string}
     * @memberof FeaturedStream
     */
    dropId?: string;
    /**
     * Whether this member currently counts on the roster.
     * @type {boolean}
     * @memberof FeaturedStream
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStream
     */
    priority?: number;
    /**
     * Always surface this member regardless of the roster's live filter.
     * @type {boolean}
     * @memberof FeaturedStream
     */
    exemptFromGameFilter?: boolean;
    /**
     * Drop ids this member is official for. Empty means the whole franchise — every title under it resolves them.
     * @type {Array<string>}
     * @memberof FeaturedStream
     */
    scopeDropIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStream
     */
    addedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStream
     */
    addedAt?: number;
    /**
     * 
     * @type {StreamStatus}
     * @memberof FeaturedStream
     */
    status?: StreamStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FeaturedStream
     */
    isLive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStream
     */
    viewerCount?: number;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStream
     */
    thumbnailUrl?: string;
    /**
     * Current live stream title (persisted by EventSub webhooks). On stream.offline this is FROZEN, not cleared, so cards can show "Was streaming last title" for recent-offline creators.
     * @type {string}
     * @memberof FeaturedStream
     */
    streamTitle?: string;
    /**
     * Platform-reported game / category name (Twitch game_name, Kick category.name, YouTube categoryId resolved). Frozen on stream.offline.
     * @type {string}
     * @memberof FeaturedStream
     */
    gameName?: string;
    /**
     * Platform game/category identifier (Twitch game_id, Kick category.id, YouTube categoryId).
     * @type {string}
     * @memberof FeaturedStream
     */
    gameId?: string;
    /**
     * Kick parent_category (e.g. "Games" → "First-Person Shooter"). Empty on Twitch / YouTube.
     * @type {string}
     * @memberof FeaturedStream
     */
    parentCategory?: string;
    /**
     * Streamer-chosen tags. Twitch tags[], Kick custom_tags[], YouTube snippet.tags[]. Frozen on stream.offline.
     * @type {Array<string>}
     * @memberof FeaturedStream
     */
    tags?: Array<string>;
    /**
     * ISO 639-1 language code reported by the platform.
     * @type {string}
     * @memberof FeaturedStream
     */
    language?: string;
    /**
     * Twitch content classification labels (e.g. "ProfanityVulgarity").
     * @type {Array<string>}
     * @memberof FeaturedStream
     */
    classificationLabels?: Array<string>;
    /**
     * Mature content flag reported by the platform.
     * @type {boolean}
     * @memberof FeaturedStream
     */
    isMature?: boolean;
    /**
     * Epoch ms — last time this featured stream was confirmed live. Drives "Was streaming Xh ago" copy on offline cards.
     * @type {number}
     * @memberof FeaturedStream
     */
    lastLiveAt?: number;
    /**
     * Streamer profile/avatar image URL
     * @type {string}
     * @memberof FeaturedStream
     */
    profileImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStream
     */
    lastCheckedAt?: number;
    /**
     * 
     * @type {LiveState}
     * @memberof FeaturedStream
     */
    liveState?: LiveState;
    /**
     * 
     * @type {LiveSource}
     * @memberof FeaturedStream
     */
    liveSource?: LiveSource;
    /**
     * Epoch ms when most-recent live-state observation was applied. Distinct from lastMetadataObservedAt.
     * @type {number}
     * @memberof FeaturedStream
     */
    lastStatusObservedAt?: number;
    /**
     * Epoch ms when metadata (viewer count, thumbnail, title) was last refreshed. Does NOT extend liveState validity.
     * @type {number}
     * @memberof FeaturedStream
     */
    lastMetadataObservedAt?: number;
    /**
     * Epoch ms — last time this stream was confirmed OFFLINE.
     * @type {number}
     * @memberof FeaturedStream
     */
    lastOfflineAt?: number;
    /**
     * 
     * @type {PresenceOverride}
     * @memberof FeaturedStream
     */
    presenceOverride?: PresenceOverride;
}



/**
 * Check if a given object implements the FeaturedStream interface.
 */
export function instanceOfFeaturedStream(value: object): value is FeaturedStream {
    return true;
}

export function FeaturedStreamFromJSON(json: any): FeaturedStream {
    return FeaturedStreamFromJSONTyped(json, false);
}

export function FeaturedStreamFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeaturedStream {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'] == null ? undefined : json['_id'],
        'label': json['label'] == null ? undefined : json['label'],
        'platform': json['platform'] == null ? undefined : StreamingPlatformFromJSON(json['platform']),
        'overrideName': json['overrideName'] == null ? undefined : json['overrideName'],
        'overrideImageUrl': json['overrideImageUrl'] == null ? undefined : json['overrideImageUrl'],
        'fieldValues': json['fieldValues'] == null ? undefined : json['fieldValues'],
        'twitchChannelId': json['twitchChannelId'] == null ? undefined : json['twitchChannelId'],
        'kickChannelSlug': json['kickChannelSlug'] == null ? undefined : json['kickChannelSlug'],
        'youtubeChannelId': json['youtubeChannelId'] == null ? undefined : json['youtubeChannelId'],
        'youtubeLiveId': json['youtubeLiveId'] == null ? undefined : json['youtubeLiveId'],
        'dropId': json['dropId'] == null ? undefined : json['dropId'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'exemptFromGameFilter': json['exemptFromGameFilter'] == null ? undefined : json['exemptFromGameFilter'],
        'scopeDropIds': json['scopeDropIds'] == null ? undefined : json['scopeDropIds'],
        'addedBy': json['addedBy'] == null ? undefined : json['addedBy'],
        'addedAt': json['addedAt'] == null ? undefined : json['addedAt'],
        'status': json['status'] == null ? undefined : StreamStatusFromJSON(json['status']),
        'isLive': json['isLive'] == null ? undefined : json['isLive'],
        'viewerCount': json['viewerCount'] == null ? undefined : json['viewerCount'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'streamTitle': json['streamTitle'] == null ? undefined : json['streamTitle'],
        'gameName': json['gameName'] == null ? undefined : json['gameName'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'parentCategory': json['parentCategory'] == null ? undefined : json['parentCategory'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'language': json['language'] == null ? undefined : json['language'],
        'classificationLabels': json['classificationLabels'] == null ? undefined : json['classificationLabels'],
        'isMature': json['isMature'] == null ? undefined : json['isMature'],
        'lastLiveAt': json['lastLiveAt'] == null ? undefined : json['lastLiveAt'],
        'profileImageUrl': json['profileImageUrl'] == null ? undefined : json['profileImageUrl'],
        'lastCheckedAt': json['lastCheckedAt'] == null ? undefined : json['lastCheckedAt'],
        'liveState': json['liveState'] == null ? undefined : LiveStateFromJSON(json['liveState']),
        'liveSource': json['liveSource'] == null ? undefined : LiveSourceFromJSON(json['liveSource']),
        'lastStatusObservedAt': json['lastStatusObservedAt'] == null ? undefined : json['lastStatusObservedAt'],
        'lastMetadataObservedAt': json['lastMetadataObservedAt'] == null ? undefined : json['lastMetadataObservedAt'],
        'lastOfflineAt': json['lastOfflineAt'] == null ? undefined : json['lastOfflineAt'],
        'presenceOverride': json['presenceOverride'] == null ? undefined : PresenceOverrideFromJSON(json['presenceOverride']),
    };
}

export function FeaturedStreamToJSON(json: any): FeaturedStream {
    return FeaturedStreamToJSONTyped(json, false);
}

export function FeaturedStreamToJSONTyped(value?: FeaturedStream | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'label': value['label'],
        'platform': StreamingPlatformToJSON(value['platform']),
        'overrideName': value['overrideName'],
        'overrideImageUrl': value['overrideImageUrl'],
        'fieldValues': value['fieldValues'],
        'twitchChannelId': value['twitchChannelId'],
        'kickChannelSlug': value['kickChannelSlug'],
        'youtubeChannelId': value['youtubeChannelId'],
        'youtubeLiveId': value['youtubeLiveId'],
        'dropId': value['dropId'],
        'enabled': value['enabled'],
        'priority': value['priority'],
        'exemptFromGameFilter': value['exemptFromGameFilter'],
        'scopeDropIds': value['scopeDropIds'],
        'addedBy': value['addedBy'],
        'addedAt': value['addedAt'],
        'status': StreamStatusToJSON(value['status']),
        'isLive': value['isLive'],
        'viewerCount': value['viewerCount'],
        'thumbnailUrl': value['thumbnailUrl'],
        'streamTitle': value['streamTitle'],
        'gameName': value['gameName'],
        'gameId': value['gameId'],
        'parentCategory': value['parentCategory'],
        'tags': value['tags'],
        'language': value['language'],
        'classificationLabels': value['classificationLabels'],
        'isMature': value['isMature'],
        'lastLiveAt': value['lastLiveAt'],
        'profileImageUrl': value['profileImageUrl'],
        'lastCheckedAt': value['lastCheckedAt'],
        'liveState': LiveStateToJSON(value['liveState']),
        'liveSource': LiveSourceToJSON(value['liveSource']),
        'lastStatusObservedAt': value['lastStatusObservedAt'],
        'lastMetadataObservedAt': value['lastMetadataObservedAt'],
        'lastOfflineAt': value['lastOfflineAt'],
        'presenceOverride': PresenceOverrideToJSON(value['presenceOverride']),
    };
}

